import type { IconSvgObject } from './types';

const CaravanIcon: IconSvgObject = [
  ["path", { d: "M19 18H21C21.5523 18 22 17.5523 22 17V16M19 18V10C19 6.68629 16.3137 4 13 4H3C2.44772 4 2 4.44772 2 5V17C2 17.5523 2.44772 18 3 18H7M19 18H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "9", cy: "18", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 7H5V12H12V7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CaravanIcon;
